import type { FC } from 'react';
import { ToastContent } from '@components/ToastContent';
import { Button } from '@components/ui/button';

interface SummaryReadyToastProps {
  renewalName?: string;
  onView: () => void;
}

/** "Summary ready" with a button that takes the broker to the summary. */
export const SummaryReadyToast: FC<SummaryReadyToastProps> = ({ renewalName, onView }) => (
  <div>
    <ToastContent
      title="Summary ready"
      description={`Your summary of changes${renewalName ? ` for ${renewalName}` : ''} is ready.`}
    />
    <Button variant="outline" size="sm" className="mt-3 bg-white" onClick={onView}>
      View summary
    </Button>
  </div>
);
